import React, { FC } from 'react'

import { Spinner } from '@Shared/Components/Spinner/Spinner'

import styles from './CheckoutFlowSpinner.module.scss'

export const CheckoutFlowSpinner: FC = () => (
  <div className={styles.checkoutFlowSpinner}>
    <Spinner />
  </div>
)

